"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var TabsSection = /** @class */ (function () {
    function TabsSection() {
    }
    TabsSection.prototype.onLoadEach = function ($element) {
        if (!$element)
            return;
        var $itemsHeadings = $element.$$(".TabsSection__item-header");
        var $itemsContentWrap = $element.$(".TabsSection__contents");
        var $itemsContents = $itemsContentWrap.$$(".TabsSection__item-content");
        var untilRefresh = (0, DOMScript_1.makeUntilRefresh)();
        $itemsHeadings &&
            untilRefresh((0, rxjs_1.fromEvent)($itemsHeadings, "click")).subscribe(function (e) {
                var $selectedItemHeading = e.currentTarget;
                var itemRef = $selectedItemHeading.dataset.item;
                var $selectedItemContent = $itemsContentWrap.$("[data-item=" + itemRef + "]");
                $itemsHeadings.forEach(function (item) {
                    item.classList.remove("--active");
                });
                $itemsContents.forEach(function (item) {
                    item.classList.remove("--active");
                });
                $selectedItemHeading.classList.add("--active");
                $selectedItemContent.classList.add("--active");
            });
    };
    TabsSection = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".TabsSection",
            isElementArray: true
        })
    ], TabsSection);
    return TabsSection;
}());
new TabsSection();
